/**
 * GOOGLE SEARCH MODULE
 *
 * This module only contains a way to manipulate the rendered Google CSE module.
 * This does not control the Google CSE.
 */

VP = window.VP || {};

(function( $ ) {
	/**
	 * PRIVATE VARIABLES
	 */
	var SELECTOR = {
		results: '.gsc-control-cse',
		resultsWrapperVisible: '.gsc-results-wrapper-visible',
		noResults: '.gs-no-results-result',
		typo: '.gs-spelling',
		dropdown: '.gsc-option-menu-container',
		optionMenuItem: '.gsc-option-menu-item',
	};
	var CLASSNAME = {
		noResults: 'no-results',
		typo: 'has-typo',
		dropdownOpen: 'open',
	};

	var $results;
	var $searchResultsWrapper;

	/**
	 * Checks if there is no result, add classname necessary
	 */
	function checkForNoResults () {
		if ( $searchResultsWrapper.find( SELECTOR.noResults ).length ) {
			$results.addClass( CLASSNAME.noResults );
		}
	}

	/**
	 * Checks if there is typo, add classname necessary
	 */
	function checkForTypo () {
		if ( $searchResultsWrapper.find( SELECTOR.typo ).length ) {
			$results.addClass( CLASSNAME.typo );
		}

		if ($('.gsc-results').length === 0) {
			return setTimeout(checkForTypo, 200);
		}
	}

	/**
	 * Overrides default dropdown behaviour
	 */
	function bindDropdown () {
		var $dropdown = $( SELECTOR.dropdown );

		$dropdown.on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			$dropdown.toggleClass( CLASSNAME.dropdownOpen );
		});

		$dropdown.find( SELECTOR.optionMenuItem ).on( 'click', function (e) {
			$dropdown.removeClass( CLASSNAME.dropdownOpen );
		});

		$('body').on('click', function () {
			$dropdown.removeClass( CLASSNAME.dropdownOpen );
		});
	}

	/**
	 * Continuously checks for the presence of search results element until present
	 */
	function pollSearchResultsElement () {
		$searchResultsWrapper = $( SELECTOR.resultsWrapperVisible );

		if ( $searchResultsWrapper && !$searchResultsWrapper.length ) {
			return setTimeout( pollSearchResultsElement, 100 );
		}

		$results = $(SELECTOR.results);
		$results.addClass( CLASSNAME.resultsWrapperReady );

		bindDropdown();
		checkForNoResults();
		checkForTypo();
	}

	/**
	 * NEWSLETTER MODULE ATTACHED TO APP
	 */
	VP.googleSearch = {
		instances: [],

		/**
		 * If the searchbox does not appear on page load,
		 * re-run the gcse srcipt unitil it appears.
		 * Clear polling interval after six tries.
		 */
		initSearchbox: function() {
			var loadAttempts = 0;
			var searchboxPollingInterval = setInterval(function() {
				var gcseEl = document.getElementById('___gcse_1');
				if (!gcseEl) {
					window.gcseCode();
				} else {
					clearInterval(searchboxPollingInterval);
					return;
				}
				loadAttempts = loadAttempts + 1;
				if (loadAttempts === 6) {
					clearInterval(searchboxPollingInterval);
				}
			}, 1000);
		},

		init: function () {

			// Search results page only
			if ( /\/search/i.test( location.pathname ) ) {
				pollSearchResultsElement();
			}

			this.initSearchbox();
		},
	};
})(jQuery);
